import React from 'react';
import { Typography, Box } from '@mui/material';

const SectionHeader = ({ 
  title, 
  subtitle, 
  align = 'center',
  maxWidth = 'lg',
  sx = {} 
}) => {
  const getMaxWidth = () => {
    switch (maxWidth) {
      case 'sm':
        return '600px';
      case 'md':
        return '800px';
      case 'lg':
        return '1000px';
      default:
        return maxWidth;
    }
  };

  return (
    <Box sx={{ 
      textAlign: align, 
      mb: { xs: 6, md: 8 }, 
      maxWidth: getMaxWidth(),
      mx: align === 'center' ? 'auto' : 'unset',
      ...sx 
    }}>
      <Typography
        variant="h3"
        sx={{
          mb: subtitle ? 2 : 0,
          fontWeight: 800,
          fontSize: { xs: '2rem', md: '2.75rem' },
          color: '#0A2540',
          letterSpacing: '-0.02em'
        }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h6"
          sx={{
            color: '#546E7A',
            fontSize: '1.15rem',
            fontWeight: 400,
            lineHeight: 1.5
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeader; 